import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7787db7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-account-status text-10" }

import { withDefaults } from "vue";
import { SupportStatusEnum } from "@/clinic/typings/enums/line-account";
import { useChangeCase } from "@vueuse/integrations/useChangeCase";
import { get } from "@vueuse/core";
import { CustomerStatusesConstants } from "@/clinic/constants/customer.constants";

type ICustomerStatus = {
  customer_status: string;
  support_status: string;
  customer_status_display_name?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'status',
  props: {
    customer_status: null,
    support_status: { default: "not_compatible" },
    customer_status_display_name: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.customer_status)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["inline-block customer-status border-round-xl text-center mr-1 px-2", __props.customer_status])
        }, _toDisplayString(__props.customer_status_display_name || _unref(CustomerStatusesConstants)[__props.customer_status]), 3))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["inline-block support-status px-2 text-center mr-1", _unref(get)(_unref(useChangeCase)(__props.support_status || '', 'snakeCase', { delimiter: '-' }))])
    }, _toDisplayString(_unref(SupportStatusEnum)[__props.support_status]), 3)
  ]))
}
}

})